import {FormControl, Switch} from '@mui/material';
import styled from 'styled-components';
import {media, theme, tokens} from '../../theme';

export const ChatContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    width: 100%;
`;

export const StyledFormControl = styled(FormControl)`
    && {
        .MuiSelect-select {
            padding: 12px;
        }

        .MuiOutlinedInput-root {
            border-radius: 8px;
            border-color: ${({theme}) => theme.palette.dividers.strong};
        }

        .MuiOutlinedInput-notchedOutline {
            border-color: ${({theme}) => theme.palette.dividers.strong};
        }

    }
`;

export const ChatWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
`;

export const ChatCard = styled.div<{ $isEmpty?: boolean }>`
    display: flex;
    flex-direction: column;
    padding: 20px;
    width: 100%;
    overflow: hidden;

    ${media.lg} {
        min-width: 860px;
        width: 50%;
    }
`;


export const HeaderActions = styled.div`
    text-align: right;
    margin-bottom: 10px;

    ${media.sm} {
        margin-bottom: 10px;
    }
`;

export const LogoWrapper = styled.div`
    text-align: center;

    img {
        width: 280px;
        height: auto;
    }
`;

export const ChatHeader = styled.div<{ $isBigSpace: boolean }>`
    font-weight: 700;
    font-size: ${tokens.fontSize.lg};
    margin-bottom: ${(props) => (props.$isBigSpace ? '40px' : '20px')};
    margin-top: ${(props) => (props.$isBigSpace ? '16px' : '0')};
    color: ${({theme}) => theme.palette.text.primary};
    
    ${media.sm} {
        font-size: ${tokens.fontSize.lg};
    }

    ${media.md} {
        font-size: ${tokens.fontSize.xl};
    }
`;

export const TopBarContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: stretch;
    width: 100%;
    margin-bottom: 20px;
    gap: 12px;

    ${media.tablet} {
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        gap: 0;
    }
`;

export const SelectTopics = styled.div`
    margin-bottom: 20px;
    width: 100%;
`;

export const UseDocumentsWrapper = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    font-size: 17px;
    margin-top: 12px;
    margin-bottom: 24px;
`

export const StyledSwitch = styled(Switch)({
    '& .MuiSwitch-switchBase.Mui-checked': {
        color: theme.palette.primary.main,
    },
    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
        backgroundColor: theme.palette.primary.main,
    },
    '& .MuiSwitch-track': {
        backgroundColor: '#A7B2BC',
    },
});

export const CenterContent = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-align: center;
`;
